<div
  class="collapse collapse--{{ open ? color : 'tertiary' }}"
  [ngClass]="{
    'collapse--open': open,
    'collapse--closed': !open,
    'collapse--sub': isSubCollapse
  }"
>
  <button class="collapse-header" (click)="toggle()">
    <div class="collapse-header__title">
      {{ title }}
    </div>
  
    <div class="collapse-header__icon">
      <i class="fas fa-chevron-right"></i>
    </div>
  </button>

  <div class="collapse-content" [@open]="open">
    <ng-content></ng-content>
  </div>
</div>
